function helloUserDirectiveFn(Identity) {
	var scope = {
		icon : "@?", // define si se muestra el ícono o no (true false)
		mode : "@?" // sefine si se mmuestra al lado del asludo (1) o encima del
	// saludo(2)
	}
	var template = function(elem, attr, s) {
		return '<h1></h1>';
	}
	var link = function(scope, element) {
		var sunIcon = angular.element('<i class="fa fa-sun-o yellow" aria-hidden="true"></i>');
		var moonIcon = angular.element('<i class="fa fa-moon-o gray" aria-hidden="true"></i>');
		var iconView = false;
		var modeView = 0;

		if (angular.isDefined(scope.icon)) {
			iconView = true;
		}
		if (angular.isDefined(scope.mode)) {
			modeView = scope.mode;
		}

		function getHelloText() {
			var text;
			var icon = sunIcon;
			var d = new Date();
			var hour = d.getHours();
			var name = Identity.claims.name.trim();
			// se obtiene solo el nombre
			var spc = name.indexOf(" ");
			if (spc >= 0)
				name = name.slice(0, spc);
			// se pone la primera letra en mayúscula y las demás en minúscula
			var prim = name.slice(0, 1).toUpperCase();
			name = name.toLowerCase();
			name = prim + name.slice(1);

			if (hour < 6 || hour >= 20) {
				text = "Buenas noches " + name;
				icon = moonIcon;
			} else if (hour >= 6 && hour < 12) {
				text = "Buenos días " + name;
			} else {
				text = "Buenas tardes " + name;
			}

			element[0].textContent = " " + text;

			if (iconView) {
				if (modeView == 1) {
					element.prepend(icon);
				} else {
					icon.addClass("fa-5x")
					element.before(icon);
				}
			}
		}

		getHelloText();
	}
	return {
		scope : scope,
		template : template,
		restrict : 'E',
		replace : true,
		link : link
	}
};
module.directive('helloUser', [ 'Identity', helloUserDirectiveFn ]);